import { isStreamIQ, isToya } from '@/shared/lib'

export const getConfigHook = async () => {
    if (isToya()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module = await require('@/clients/toya/hooks/useConfig')
            return module.useConfig
        } catch (error) {
            console.warn(
                'useConfig module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            const module =
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                await require('@/clients/streamiq/shared/hooks/useConfigStreamiq')
            return module.useConfigStreamIQ
        } catch (error) {
            console.warn(
                'useConfigStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
